const messagesEn = {
    'Alt innhold': 'All content',
    'Artikler': 'Articles',
    'Linje ved': 'Course at',
    'Linjer': 'Courses',
    'Skoler': 'Schools',
    'Skoletur ved': 'Schooltrip at',
    "A-Å": "A-Z",
    "Alfabetisk": "Alphabetically",
    "Alle linjer": "All courses",
    "Ditt søk ga": "Showing",
    "Få ledige plasser": "Few available places",
    "Fagområde": "Subject category",
    "Fagområder": "Subject categories",
    "Fant ingen skoler": "No schools found",
    "Finn din skole": "Find your school",
    "Finn din linje": "Find course",
    "Fjern alle": "Remove all",
    "Flere valg": "Filter courses",
    "Frilynt": "Liberal",
    "Full": "Fully booked",
    "Halvår høst": "Half year autumn",
    "Halvår vår": "Half year spring",
    "Halvår vår": "Half year spring",
    "Halvår — vår": "Half year spring",
    "Halvår — høst": "Half year autumn",
    "Halvårskurs høst": "Half year autumn",
    "Halvårskurs vår": "Half year spring",
    "Her kan du velge én eller flere fagområder og underkategorier for å spisse søket ditt.": "Select one or more subject categories to refine your search.",
    "Helår": "All year",
    "Helårskurs": "Whole year",
    "helårslinje": "whole year course",
    "helårslinjer": "whole year courses",
    "halvårslinje": "half year course",
    "halvårslinjer": "half year courses",
    "Hjem": "Home",
    "Intro": "About",
    "Kontakt skolen": "Contact the school",
    "Kortkurs": "Short course",
    "Kristen": "Christian",
    "Kurslengde": "Course length",
    "Landsdel": "Region",
    "Ledig plass": "Available",
    "linjer": "courses",
    "Linjer": "Courses",
    "Midt-Norge": "Middle Norway",
    "Nord-Norge": "Northern Norway",
    "Nullstill": "Reset",
    "Nullstill": "Reset",
    "Østlandet": "Eastern Norway",
    "Pris": "Price",
    "Resultat": "Result",
    "Skjul kart": "Hide map",
    "Skole": "School",
    "Skoler med et kristent verdigrunnlag": "Schools based on cristian values",
    "Skoler som ikke tar utgangspunkt i ett bestemt livssyn": "Schools without a religious foundation",
    "skoler": "schools",
    "Skriv inn linjenavn": "Enter course name",
    "Søk skolenavn...": "Search...",
    "Søk": "Search",
    "Sørlandet": "Southern Norway",
    "Sortering": "Ordering",
    "Sorteringsrekkefølge": "Sort order",
    "t/uke": "h/week",
    "Tilfeldig": "Random",
    "treff": "hits",
    "Velg type innhold": "Choose content types",
    "Venteliste": "Waiting list",
    "Verdigrunnlag": "Affiliation",
    "Vestlandet": "Western Norway",
    "Vis flere": "Show more",
    "Vis i kart": "Show map",
    "Vis kart": "Show map",
    "Vis": "Show",
};

export default function (message, lang) {
  if (lang === 'en' && messagesEn[message]) {
    return messagesEn[message];
  } else {
    return message;
  }
}